import {Component, Input} from '@angular/core';
import {ActivityStatus} from '../../domain/activity-status.model';

@Component({
  selector: 'cm-activity-status-circle',
  template: `
    <span class="status-circle"
      [ngClass]="{
        'status-circle--green': status === ActivityStatus.ACTIVE
       , 'status-circle--blue': status === ActivityStatus.READY
       , 'status-circle--orange': status === ActivityStatus.DRAFT || status === ActivityStatus.PENDING
       , 'status-circle--gray': status === ActivityStatus.ARCHIVED
       , 'status-circle--red': status === ActivityStatus.INACTIVE}">
      <i class="fas fa-circle"></i>
  </span>`
})
export class ActivityStatusCircleComponent {

  @Input()
  public status: ActivityStatus;

  public ActivityStatus = ActivityStatus;

}
